
angular
    .module('app')
    .component('addons', {
        templateUrl: 'app/components/addons/Addons.html',
        controller: Addons
    });


function Addons($rootScope, Params, Restangular, $state, ENV, $translate, $window, OffersManager, OffersParser, ConfigBookingEngine, Currency) {
    var $this = this;
    $this.$rootScope = $rootScope;
    $this.Params = Params;
    $this.Restangular = Restangular;
    $this.$state = $state;
    $this.ENV = ENV;
    $this.$translate = $translate;
    $this.$window = $window;
    $this.OffersManager = OffersManager;
    $this.OffersParser = OffersParser;
    $this.ConfigBookingEngine = ConfigBookingEngine;
    $this.Currency = Currency;
}


Addons.prototype = {
    $onInit: function () {
        this.selectedAddons = [];
        this.addons = [];
        this.roomGroupCategoryFilterId = this.Params.getRoomGroupCategoryFilterId();
        this.categoryId = this.Params.getCategoryId();
        this.viewType = this.Params.getViewType();
        this.checkIn = this.Params.getCheckIn();
        this.checkOut = this.Params.getCheckOut();
        this.lengthOfStay = moment(this.checkOut).diff(this.checkIn, "days");
        this.occupancy = this.Params.getOccupancy();
        this.discountCode = this.Params.getDiscountCode();
        this.cart = this.Params.getCart() || [];
        this.hotelId = this.Params.getHotelId();
        this.language = this.Params.getLanguage();
        this.obligatoryAddons = [];
        this.getAddons();
        this.getOffers();
    },

    getOffers: function () {
        var $this = this;
        

        $this.$rootScope.$emit("startLoading", {
            title: this.$translate.instant("loader.PLEASE_WAIT"),
            description: this.$translate.instant("loader.AVAILABILITY"),
        });

        /* eslint-disable camelcase */
        var requestParams = {
            start: moment($this.checkIn).format("YYYY-MM-DD"),
            end: moment($this.checkOut).subtract(1, "day").format("YYYY-MM-DD"),
            hotel_id: this.hotelId,
            language: this.language,
            discount_code_name: this.discountCode,
        };
        /* eslint-enable camelcase */
        $this.Restangular.all("")
            .customGET(
                "bookingengine/api/be/preorders?" + this.getItemsForApiGet(),
                requestParams
            )
            .then(function (preOrder) {
                $this.priceSummary = preOrder.summary;
                $this.obligatoryAddons = $this.parseObligatoryAddons();
            })
            .catch(function (e) {
                console.log('error: ', e);
                $this.$state.go("booking.clientErrors", {}, { location: false });
            })
            .finally(function () {
                if($this.addons.filter(addon => !addon.obligatory).length === 0){
                    $this.goToNextStep();
                }
            });
    },

    getItemsForApiGet: function () {
        var url = "";
        var items = this.cart;
        var ageGroups = this.ConfigBookingEngine.getAgeCategories();
        var addons = this.selectedAddons;

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            url +=
                "items[" +
                i +
                "][group_id]=" +
                item.roomId +
                "&items[" +
                i +
                "][rateplan_id]=" +
                item.rateplanId +
                "&items[" +
                i +
                "][persons_count]=" +
                item.persons;

            for (var j = 0; j < item.categories.length; j++) {
                url += `&items[${i}][age_counts][${ageGroups[j].id}]=${item.categories[j]}`
            }

            for (var j = 0; j < addons.length; j++) {
                var addon = addons[j];
                if ((addon.priceMode === 0 || addon.priceMode === 1) && i > 0)
                    continue;

                url += `&items[${i}][add_ons][${addon.id}]=${addon.quantity}`;
            }

            if (i < items.length - 1) {
                url += "&";
            }
        }
        return url.trim();
    },

    getSummary: function (offers) {
        var result = {};
        result.items = [];
        for (var i = 0; i < this.cart.length; i++) {
            var cartItem = this.cart[i];
            var addons = offers[i].add_ons || [];

            var offer = this.searchItemInOffers(
                cartItem.roomId,
                cartItem.rateplanId,
                cartItem.persons,
                addons
            );
            result.items.push(offer);
        }
        return this.isValidSummary(result) ? result : null;
    },

    searchItemInOffers: function (roomId, rateplanId, personsCount, addons) {
        var offer = this.filteredOffersList.filter(function (offer) {
            return offer.room.id === roomId;
        })[0];

        if (angular.isUndefined(offer)) {
            return null;
        }

        var rateplan = offer.rateplans.filter(function (rateplan) {
            return rateplan.id === rateplanId;
        })[0];

        if (angular.isUndefined(rateplan)) {
            return null;
        }

        var price = rateplan.prices.filter(function (price) {
            return price.personsCount === personsCount;
        })[0];

        if (angular.isUndefined(price)) {
            return null;
        }

        return {
            room: offer.room,
            rateplan: rateplan,
            prices: price,
            addons: addons
        };
    },

    isValidSummary: function (summary) {
        if (!angular.isArray(summary.items)) {
            return false;
        }

        if (summary.items.length === 0) {
            return false;
        }

        for (var i = 0; i < summary.items.length; i++) {
            var item = summary.items[i];
            if (item === null || angular.isUndefined(item)) {
                return false;
            }

            if (item.room === null || angular.isUndefined(item.room)) {
                return false;
            }

            if (item.rateplan === null || angular.isUndefined(item.rateplan)) {
                return false;
            }

            if (item.prices === null || angular.isUndefined(item.prices)) {
                return false;
            }
        }

        return true;
    },

    getAddons: function () {
        var $this = this;
        $this.$rootScope.$emit("startLoading", {
            title: this.$translate.instant("loader.PLEASE_WAIT"),
            description: this.$translate.instant("loader.AVAILABILITY"),
        });

        var items = this.cart;
        var ageGroups = this.ConfigBookingEngine.getAgeCategories();
        var url = "";

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var requestParams = {
                language: this.language,
                persons_count: item.persons,
                room_group_id: item.roomId,
                start: moment($this.checkIn).format("YYYY-MM-DD"),
                end: moment($this.checkOut).subtract(1, "day").format("YYYY-MM-DD")
            };

            for (var j = 0; j < item.categories.length; j++) {
                var symbol = j === 0 ? "?" : "&";
                url += `${symbol}items[${i}][age_counts][${ageGroups[j].id}]=${item.categories[j]}`
            }

            $this.Restangular.all("bookingengine/api/be/hotels/" + this.hotelId + "/addons" + url)
                .getList(requestParams)
                .then(function (response) {
                    if (!Array.isArray(response)) {
                        return;
                    }

                    for (var j = 0; j < response.length; j++) {
                        var addon = response[j];
                        var index = $this.addons.findIndex(item => item.id === addon.id);
                        if (index === -1) {
                            if (addon.type !== 'Assortment' && (addon.priceMode === 3 || addon.priceMode === 0)) {
                                addon.pricePerUnit *= $this.occupancy.length;
                            }

                            if (addon.priceMode === 3 || addon.priceMode === 4) {
                                addon.pricePerUnit *= $this.lengthOfStay;
                            }

                            $this.addons.unshift(addon);
                        }
                        // else {
                        //     $this.addons[index].pricePerUnit += addon.pricePerUnit;
                        // }
                    }
                })
                .catch(function (e) {
                    console.log('error: ', e);
                })
                .finally(function () {
                    if(i == items.length){
                        console.log(i);
                    }
                });
        }

        // if ($this.addons.length === 0) {
        //     console.log('step')
        //     $this.goToNextStep();
        // }
    },

    getSummaryPrice: function () {
        if (typeof this.priceSummary == undefined || !this.priceSummary || !this.priceSummary.price) {
            return this.Currency.getFormattedPrice(0);
        }

        var price = this.getOptionalAddonsPrice();

        if (this.priceSummary.discount_price > 0) {
            price += this.priceSummary.discount_price;
        } else {
            price += this.priceSummary.price;
        }

        return this.Currency.getFormattedPrice(price);
    },

    getAccommodationPrice: function () {
        if (typeof this.priceSummary == undefined || !this.priceSummary || !this.priceSummary.accommodation_price) {
            return this.Currency.getFormattedPrice(0);
        }

        return this.Currency.getFormattedPrice(this.priceSummary.accommodation_price);
    },

    hasDiscount: function () {
        if (!this.priceSummary || !this.priceSummary.discount_price) {
            return false;
        }

        var price = this.priceSummary.price - this.priceSummary.discount_price;
        return price > 0;
    },

    getDiscount: function () {
        if (this.priceSummary.discount_price === null) {
            return this.Currency.getFormattedPrice(0);
        }

        var price = this.priceSummary.discount_price - this.priceSummary.price;
        price = price.toFixed(2);
        if (price != null) {
            return this.Currency.getFormattedPrice(price);
        }
        return this.Currency.getFormattedPrice(0);
    },

    getFormattedPrice: function (price) {
        return this.Currency.getFormattedPrice(price);
    },

    getObligatoryAddons: function () {
        if (!this.addons || !Array.isArray(this.addons)) {
            return [];
        }

        return this.addons.filter(addon => addon.obligatory === true);
    },

    parseObligatoryAddons: function () {
        if (!this.priceSummary || !this.priceSummary.add_ons) {
            return [];
        }

        var obligatoryAddons = angular.copy(this.priceSummary.add_ons);
        var groupedAddons = [];

        for (var i = 0; i < obligatoryAddons.length; i++) {
            var addon = obligatoryAddons[i];
            var index = groupedAddons.map(function (item) { return item.id }).indexOf(addon.id);
            if (index > -1) {
                groupedAddons[index].total_price += addon.total_price;
            } else {
                groupedAddons.push(addon);
            }
        }

        this.$rootScope.$emit('stopLoading');
        return groupedAddons;
    },

    getOptionalAddonsPrice: function () {
        var price = 0;
        for (var i = 0; i < this.selectedAddons.length; i++) {
            var addon = this.selectedAddons[i];
            var addonPrice;

            if (addon.priceMode === 1 || addon.priceMode === 2 || addon.type === 'Assortment') {
                addonPrice = addon.pricePerUnit * addon.count;
            } else if (addon.priceMode === 4) {
                addonPrice = addon.pricePerUnit * addon.count;
            } else {
                addonPrice = addon.pricePerUnit;
            }

            price += addonPrice;
        }

        return price;
    },

    getOptionalAddonsPriceFormated: function () {
        var price = this.getOptionalAddonsPrice();
        return this.Currency.getFormattedPrice(price);
    },

    getOptionalAddons: function () {
        if (!this.addons || !Array.isArray(this.addons)) {
            return [];
        }

        return this.addons.filter(addon => addon.obligatory === false);
    },

    handleSave: function (addon) {
        var addonIndex = this.selectedAddons.findIndex(add => add.id === addon.id);

        if (addon.count === 0 && addonIndex > -1) {
            this.selectedAddons.splice(addonIndex, 1);
        } else if (addon.count > 0 && addonIndex > -1) {
            this.selectedAddons[addonIndex].count = addon.count;
        } else {
            this.selectedAddons.push(addon);
        }
    },

    goToPreviousStep: function () {
        this.$state.go("booking.offers", {
            checkIn: moment(this.checkIn).format("YYYY-MM-DD"),
            checkOut: this.checkOut,
            occupancy: encodeURIComponent(angular.toJson(this.occupancy)),
            discountCode: this.discountCode,
            viewType: this.viewType
        });
    },

    goToNextStep: function () {
        var formatedAddons = [];
        for (var i = 0; i < this.selectedAddons.length; i++) {
            var addon = this.selectedAddons[i];
            formatedAddons.push({ id: addon.id, quantity: addon.count, priceMode: addon.priceMode });
        }

        // var obligatory = this.getObligatoryAddons();
        // for (var i = 0; i < obligatory.length; i++) {
        //     var addon = obligatory[i];
        //     formatedAddons.push({ id: addon.id, quantity: addon.quantity, priceMode: addon.priceMode });
        // }

        this.$state.go('booking.guest', {
            checkIn: moment(this.checkIn).format('YYYY-MM-DD'),
            checkOut: moment(this.checkOut).format('YYYY-MM-DD'),
            occupancy: encodeURIComponent(angular.toJson(this.occupancy)),
            cart: encodeURIComponent(angular.toJson(this.cart)),
            discountCode: this.discountCode,
            viewType: this.viewType,
            addons: encodeURIComponent(angular.toJson(formatedAddons))
        });
    }
}